import React from 'react';
import { TripStep } from '../trips-root-component/trip-step-1';
import { useDispatch } from 'react-redux';
import { getTrips, resetTripsData } from '../../../actions/trip-actions';

export const TripForm = (props) => {

    const {
        formData,
        updateformData
    } = props;


    const dispatch = useDispatch();
    return (
        <div style={{ padding: '10px', marginTop: '15px' }}>
            <TripStep
                showDeleteButton={true}
                showCancelButton={true}
                showVechicleInfo={true}
                showUpdateButton={true}
                showFareInfo={true}
                showEditBlockSeats={true}
                showEasyTripButton={true}
                formData={formData}
                onClear={() => {
                    updateformData({});
                    dispatch(resetTripsData());
                }}
                onCreateSuccess={() => {
                    updateformData({});
                    dispatch(resetTripsData());
                    dispatch(getTrips(global.travelsId));
                }}
            />
        </div>
    );
}
